import React from 'react';
import 'twin.macro';
import { DocumentTextIcon } from '@heroicons/react/24/outline';
import { CJEvent } from 'types/event';
import { useSchoolGoTo } from 'containers/App/useSchoolGoTo';
import Popover from 'components/Popover';
import { FdpPreview } from 'containers/Sequences/List/Sidebar/PreviewButton';
import Button from 'components/Buttons/Button';
import Tooltip2 from 'components/Tooltip2';
import { useTranslation } from 'react-i18next';
import { useFieldsToDisplay } from 'containers/CahierJournal/Toolbar/Filters/FieldsToDisplay/atom';
import { useNavigate } from 'react-router-dom';
import { ProgressionIcon } from 'components/Icons/icons/ProgressionIcon';

interface Props {
  event: CJEvent;
  print?: boolean;
}

export function Footer(props: Props) {
  const { event } = props;
  const schoolGoTo = useSchoolGoTo();
  const navigate = useNavigate();
  const { t } = useTranslation(['cahierJournal']);
  const fieldsToDisplay = useFieldsToDisplay();
  const shouldDisplayLinkedFichesDePrep =
    fieldsToDisplay?.includes('fichesDePrep') &&
    event.linkedFichesDePrep.length > 0;
  const shouldDisplayLinkedProgItem =
    fieldsToDisplay?.includes('progItems') && event.programmationItemId;
  if (!shouldDisplayLinkedFichesDePrep && !shouldDisplayLinkedProgItem) {
    return null;
  }

  return (
    <div tw="border-t border-neutral-quiet py-2 px-4">
      <div tw="flex gap-x-0.5">
        {shouldDisplayLinkedFichesDePrep && (
          <>
            {event.linkedFichesDePrep.map(fdp => (
              <Popover portal hover tw="block" fill key={fdp.id}>
                <Popover.Button
                  aria-label={`Voir la fiche de préparation ${fdp.label}`}
                  onClick={() => {
                    navigate(`/fiches-de-prep/${fdp.id}`);
                  }}
                  minimal
                  icon={DocumentTextIcon}
                />
                <Popover.Panel size="xl">
                  <FdpPreview fdpId={fdp.id} />
                </Popover.Panel>
              </Popover>
            ))}
          </>
        )}
        {shouldDisplayLinkedProgItem && (
          <Tooltip2 label={t('cahierJournal:goToProgression')}>
            <Button
              minimal
              icon={ProgressionIcon as any}
              onClick={e => {
                e.stopPropagation();
                schoolGoTo(
                  `programmations/item-redirect/${event.programmationItemId}`,
                );
              }}
            ></Button>
          </Tooltip2>
        )}
      </div>
    </div>
  );
}
